import { useSelectedValueAttributeByKey } from '@k3/core'
import { useState } from 'react'
import { cover } from '../../utility/constant/helper.constant'
import { TTyp } from '../../utility/type/terraceCover.type'

/**
 * Values and methods are used by the context API
 * @returns states being used to manipulate the scene
 */

export const useStateTyp = () => {
  const [width, setWidth] = useState(8)
  const [depth, setDepth] = useState(8)
  const [typ, setTyp] = useState<TTyp>(cover.terraceCover.typ)


  const onHandleTyp = (value: TTyp) => {
    setTyp(value)
  
  }    

  const onHandleDepthAndWidth = (valueWidth: any, valueDepth: any) => {
     setWidth(valueWidth)
     setDepth(valueDepth)
  }

  return {
    typ: {
      typ,
      width,
      depth,
    },

    typMethod: {
      onHandleTyp,
      onHandleDepthAndWidth,
    },
  }
}
